<template>
  <div class="publish main" v-loading="loading" >
    <div v-if="isPC">
      <div v-show="!emptyAllData">
        <div class="top_title">{{ $t('publishListings.listings') }} <span v-if="moreParams.taskNos.length" style="color: red;">{{ `(${moreParams.taskNos})`}}</span></div>
        <div class="f-b bg-white filtrate">
          <div style="height: 60px;padding-left: 15px" class="f--c">
            <el-select v-model="moreParams.platformCode" style="width: 140px;margin-right: 10px" @change="platformChange">
              <el-option v-for="item in platformOptions" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
            </el-select>
            <el-select v-model="moreParams.storeIds" style="width: 200px;margin-right: 10px" :placeholder="$t('publishListings.SelectStore')" clearable multiple :collapse-tags="true" @change="tabClick" filterable >
              <el-option v-for="item in storeSelectList" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
            </el-select>
            <el-select v-if="moreParams.platformCode !== 'PD'" v-model="moreParams.skuCodeStatus" clearable multiple :collapse-tags="true" placeholder="Kaka Status" style="width: 190px;margin-right: 10px" @change="tabClick">
              <el-option :label="$t('publishListings.available')" :value="1"></el-option>
              <el-option :label="$t('publishListings.soldOut')" :value="4"></el-option>
              <el-option :label="$t('publishListings.notAvailable')" :value="0"></el-option>
            </el-select>
            <div class="f formGroup">
              <el-select v-model="searchString" slot="prepend" style="width: 140px;">
                <el-option :label="moreParams.platformCode === 'PD' ? 'SPU Id' : 'Product Id'" value="productIds"></el-option>
                <el-option v-if="moreParams.platformCode === 'PD'" :label="$t('publishListings.productName')" value="productName"></el-option>
                <el-option v-else :label="$t('publishListings.productName')" value="title"></el-option>
                <el-option label="SKU" value="skus"></el-option>
                <el-option :label="moreParams.platformCode === 'PD' ? 'SPU' : 'Item No'" value="spuCodes"></el-option>
              </el-select>
              <el-popover placement="top" width="400" trigger="click" v-if="['productIds', 'skus', 'spuCodes'].includes(searchString)">
                <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="batchSearchValue"></el-input>
                <div slot="reference">
                  <el-input :placeholder="$t('publishListings.searchBy')" v-model="batchSearchValue" style="width: 350px;"></el-input>
                </div>
              </el-popover>
              <el-input :placeholder="$t('publishListings.searchBy')" v-model="singleSearchValue" style="width: 350px;" v-else></el-input>
              <el-button icon="el-icon-search" round type="primary" @click="tabClick"></el-button>
            </div>
          </div>
        </div>
        <div class="bg-white">
          <el-tabs v-model="activeName" class="myTabs" @tab-click="$refs[point[activeName]].getList(moreParams)">
            <el-tab-pane :label="`${moreParams.platformCode === 'TT' ? $t('publishListings.Active') : $t('publishListings.Published')} (${PublishedTotal})`" name="1">
              <tableList
              tabTitle="Published"
              ref="Published"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
            <el-tab-pane v-if="moreParams.platformCode !== 'PD'" :label="`${moreParams.platformCode === 'TT' ? $t('publishListings.Inactive') : $t('publishListings.Hidden')} (${HiddenTotal})`" name="2">
              <tableList
              tabTitle="Hidden"
              ref="Hidden"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
            <el-tab-pane v-if="moreParams.platformCode === 'TT'" :label="`${$t('publishListings.Suspended')} (${SuspendedTotal})`" name="6">
              <tableList
              tabTitle="Suspended"
              ref="Suspended"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
            <el-tab-pane v-if="moreParams.platformCode !== 'PD'" :label="`${$t('publishListings.WaitingForUpdate')} (${WaitingForUpdateTotal})`" name="7">
              <tableList
              tabTitle="WaitingForUpdate"
              ref="WaitingForUpdate"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
            <el-tab-pane :label="`${$t('publishListings.ListingQueue')} (${ListingQueueTotal})`" name="4">
              <tableList
              tabTitle="ListingQueue"
              ref="ListingQueue"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
            <!-- Deleted 2025.10.27 张庆辉 隐藏删除 -->
            <!-- <el-tab-pane v-if="moreParams.platformCode !== 'PD'" :label="`${$t('publishListings.Deleted')} (${DeletedTotal})`" name="3">
              <tableList
              tabTitle="Deleted"
              ref="Deleted"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane> -->
            <el-tab-pane :label="`Sku No Exist (${SkuNoExistTotal})`" name="5" v-if="$store.state.common.userGroup === 100 && moreParams.platformCode !== 'PD'">
              <tableList
              tabTitle="SkuNoExist"
              ref="SkuNoExist"
              @getTotal="getTotal"
              @refresh="refresh"
              :moreParams="moreParams"
              :searchString="searchString"
              :batchSearchValue="batchSearchValue"
              :singleSearchValue="singleSearchValue"
              :platformCode="moreParams.platformCode"
              @toDeleted="toDeleted"
              @shopifyUpgrade="shopifyUpgrade"></tableList>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div v-show="emptyAllData" class="bg-white">
        <div style="padding-top: 20px;padding-left: 20px;">
          <el-select v-model="moreParams.platformCode" style="width: 140px;margin-right: 10px" @change="platformChange">
            <el-option v-for="item in platformOptions" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
          </el-select>
        </div>
        <emptyData></emptyData>
      </div>
    </div>
    <MTList v-else></MTList>

    <el-dialog :visible.sync="dialogStoreUpdate.dialog" :title="dialogStoreUpdate.title" width="80%" class="dialogStoreUpdate">
      <div style="padding-bottom: 20px">{{ dialogStoreUpdate.message }}</div>
      <div style="text-align: right;">
        <el-button @click="dialogStoreUpdate.dialog = false">Cancel</el-button>
        <el-button type="primary" @click="storeUpdate">Update</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableList from './components/tableList.vue'
import API from '@/api'
import MTList from './components/MTList.vue'
import emptyData from './components/emptyData.vue'
const point = {
  1: 'Published',
  2: 'Hidden',
  3: 'Deleted',
  4: 'ListingQueue',
  5: 'SkuNoExist',
  6: 'Suspended',
  7: 'WaitingForUpdate'
}
export default {
  name: 'listings',
  components: {
    tableList,
    MTList,
    emptyData
  },
  data() {
    return {
      activeName: '1',
      PublishedTotal: 0,
      HiddenTotal: 0,
      ListingQueueTotal: 0,
      DeletedTotal: 0,
      WaitingForUpdateTotal: 0,
      SkuNoExistTotal: 0,
      SuspendedTotal: 0,
      loading: false,
      storeSelectList: [],
      moreParams: {
        platformCode: 'SP',
        storeIds: [],
        taskNos: [],
        spuCodes: []
      },
      point,
      searchString: 'productIds',
      batchSearchValue: '',
      singleSearchValue: '',
      popoverVisible: false,
      emptyAllData: false,

      dialogStoreUpdate: {
        dialog: false,
        title: 'Tips',
        message: 'Update the Shopify app to list new products!',
        url: undefined
      }
    }
  },
  computed: {
    platformOptions() {
      if (!this.$store.state.common.platformOptions.length) this.$store.dispatch('common/getPlatformOptions')
      return this.$store.state.common.platformOptions.filter(e => e.platformCode !== 'KA')
    }
  },
  async mounted() {
    if (this.$route.query.skuCodeStatus) {
      let skuCodeStatus = this.$route.query.skuCodeStatus.split(',')
      if (skuCodeStatus.length) {
        this.$set(this.moreParams, 'skuCodeStatus', skuCodeStatus.map(item => +item))
      }
    }
    if (this.$route.query.platformCode) {
      this.$set(this.moreParams, 'platformCode', this.$route.query.platformCode)
    }
    if (this.isPC) {
      const point = {
        'Published': '1',
        'Hidden': '2',
        'Deleted': '3',
        'ListingQueue': '4',
        'Suspended': '6',
        'WaitingForUpdate': '7'
      }
      // 在edit刊登完出来，默认跳转到队列中的tab
      if (this.$route.query.activeName) {
        this.activeName = point[this.$route.query.activeName]
      }
      if (this.$store.state.published.publishedListMoreParams) {
        const { platformCode, storeIds, taskNo, searchString } = this.$store.state.published.publishedListMoreParams
        // 获取用户平台店铺 shopify > tiktok > Woocommerce > shoplazza > shopline > temu
        Object.assign(this.moreParams, { platformCode, storeIds, taskNo })
        if (!platformCode) {
          const userPlatform = await API.getUserPlatform()
          this.$set(this.moreParams, 'platformCode', userPlatform.data && userPlatform.data.length ? userPlatform.data[0].platformCode : 'SP')
        }
        this.searchString = searchString || 'productIds'
        if (['productIds', 'skus'].includes(searchString)) {
          this.batchSearchValue = this.$store.state.published.publishedListMoreParams[searchString]
        } else {
          this.singleSearchValue = this.$store.state.published.publishedListMoreParams[searchString]
        }
      }
      if (this.$route.query.platformCode) {
        this.moreParams.platformCode = this.$route.query.platformCode
      }
      if (this.$route.query.taskNo) {
        this.moreParams.taskNos = [this.$route.query.taskNo]
      }
      this.orderGetAllStore(this.moreParams.platformCode)
    }
    this.getAllData()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getTotal(value) {
      this[`${value.tabTitle}Total`] = value.total
    },
    tabClick() {
      this.moreParams.taskNos = []
      const moreParams = {
        ...this.moreParams,
        searchString: this.searchString,
        [this.searchString]: ['productIds', 'skus', 'spuCodes'].includes(this.searchString) ? this.batchSearchValue : this.singleSearchValue
      }
      // 缓存参数
      this.$store.commit('published/set', { publishedListMoreParams: moreParams })
      this.$refs[point[this.activeName]].getList()
      // if (this.$store.state.common.userGroup === 100) this.$refs['SkuNoExist'].SkuNoExistGetTotal(this.moreParams)
    },
    getMoreParams() {
      const params = Object.assign({}, this.moreParams)
      if (['productIds', 'skus', 'spuCodes'].includes(this.searchString) && this.batchSearchValue) {
        // 优先换行
        let values
        if (this.batchSearchValue.includes('\n')) values = this.batchSearchValue.split('\n')
        else values = this.batchSearchValue.split(',')
        values = values.filter(e => e)
        params[this.searchString] = values
      } else if (this.singleSearchValue) {
        params.title = this.singleSearchValue
      }
      return params
    },
    async getAllData() {
      const moreParams = this.getMoreParams()
      if (this.moreParams.platformCode !== 'TT' && +this.activeName === 6) this.activeName = '1'
      await this.$refs[point[this.activeName]].getList(moreParams)
      if (this.$store.state.common.userGroup === 100 && moreParams.platformCode !== 'PD') this.$refs['SkuNoExist'].SkuNoExistGetTotal(this.moreParams, 'userGroup')
      // if (this.moreParams.platformCode === 'SP') this.$refs['WaitingForUpdate'].SkuNoExistGetTotal(this.moreParams, 'updated')
      this.$refs[point[this.activeName]].resetSelection()
    },
    // 第一次加载时获取shopify店铺
    orderGetAllStore(platformCode) {
      return new Promise((resolve, reject) => {
        API.orderGetAllStore({ platformCode, userId: this.$store.state.common.userId, storeStatus: 1, authorizeStatus: 1 }).then(res => {
          this.storeSelectList = res.data
          this.emptyAllData = !(res.data && res.data.length)
          resolve()
        }).catch(() => reject())
      })
    },
    platformChange() {
      this.orderGetAllStore(this.moreParams.platformCode)
      this.moreParams.storeIds = []
      this.moreParams.taskNos = []
      this.$nextTick(() => {
        this.getAllData()
        // if (this.$store.state.userGroup === 100) this.$refs['SkuNoExist'].SkuNoExistGetTotal(this.moreParams)
      })
      this.$store.commit('published/set', { publishedListMoreParams: this.moreParams })
    },
    refresh(tabTitle) {
      this.$refs[tabTitle].getList(this.moreParams)
    },
    showTextare(e) {
      this.popoverVisible = !this.popoverVisible
    },
    toDeleted() {
      this.activeName = '3'
      this.$refs[point[this.activeName]].getList(this.moreParams)
    },

    storeUpdate() {
      window.open(this.dialogStoreUpdate.url, '_blank')
    },
    shopifyUpgrade(url) {
      this.dialogStoreUpdate.dialog = true
      this.dialogStoreUpdate.url = url
    }
  }
}
</script>

<style scoped lang="scss">
.dialogStoreUpdate {
  /deep/ .el-dialog {
    max-width: 700px;
  }
}
.myTabs {
  /deep/.el-tabs__nav-scroll {
    margin-left: 40px;
  }
  /deep/.el-tabs__header {
    margin-bottom: 4px;
  }
}
.top_title {
  font-size: 18px;
  font-weight: 550;
  height: 60px;
  line-height: 60px;
}
.formGroup {
  >.el-select {
    /deep/.el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-input {
    /deep/.el-input__inner {
      border-radius: 0 !important;
      border-left: 0px;
      border-right: 0px;
    }
  }
  .el-input-group__append {
    background-color: rgba(153, 196, 28, 0.2) !important;
  }
  .el-button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    background-color: rgba(153, 196, 28, 0.2) !important;
    border: 1px solid #DCDFE6;
    color: #909399;
  }
}
.inputGroup {
    width: 550px;
    /deep/.el-input-group__append {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        background-color: rgba(153, 196, 28, 0.2);
    }
    /deep/.el-input-group__prepend {
    background-color: #fff;
  }
}
.searchSelect {
  // background-color: #fff;
  /deep/.el-input__inner {
    background-color: #fff;
  }
}
.emptyData {
  padding-top: 40px;
}

.filtrate {
  /deep/ .el-select__tags-text{
    max-width: 70px;
  }
}
</style>
